export enum HandoutAssignmentStatusEnum {
  NotViewed = 'not_viewed',
  Resubmitted = 'resubmitted',
  Reviewed = 'reviewed',
  Submitted = 'submitted',
  Viewed = 'viewed',
}
